import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import EditSettingsController from './EditSettingsController';


import panel from '../../services';

export default angular.module('app.editSettings', [uirouter, panel])
    .config(routing)
    .controller('EditSettingsController', EditSettingsController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/edit-settings/index.js